import React, { Component } from 'react'
import './index.css'
import { BsyUtils } from "../../utils/Utils";
import BsyTableList from "../BsyTableList";
import LoginAccountInput from "../../Login/LoginAccountInput";
import BsyIconBtn from "../BsyIconBtn";
import emptyDockUser from "../../images/img_wudaiban@2x.png";
import BsyRadioGroup from '../BsyRadioGroup';
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyDialog from '../BsyDialog';
import BsyAlertListDetail from '../BsyAlertListDetail';

class CorpDeptUserPane extends Component {
    static defaultProps = {
        deptId: "",
        name: "",
        userList: []
    }
    constructor(props) {
        super(props);
        this.state = {
            limit: 20,
            skip: 0,
            deptId: props.deptId,
            userList: [],
            name: props.name,
            dock_corpid: props.dock_corpid,
        }
    }

    componentDidMount(){
        this.RefreshLis();
    }

    RefreshLis = () =>{
        const {limit, skip, deptId, dock_corpid} = this.state;
        const {corpUserType} = this.props;
        React.axios('/corp/department/list_member', {
            deptId: deptId,
            dock_corpid: (corpUserType === "other" || corpUserType === "otherDept") ? dock_corpid : undefined,
            hasCount: !0,
            hasChild: !1,
            filter: "",
            limit: limit,
            searchType: 'all',
            skip: skip * limit,
            job_title: "",
            status: 0,
            hasDock: !0
        }).then(res => {
            this.setState({userList: res.data.users, count: res.data.count })
        }).catch(res => {

        })
    }

    getTableValue = (ref) =>{
        console.log(ref)
    }

    closeAlert = () =>{
        this.props.newProps && this.props.newProps.props &&  this.props.newProps.props.onRemoveRoot && this.props.newProps.props.onRemoveRoot();
    }

    skipChange = (e) =>{
        this.setState({skip: e},()=>{this.RefreshList()})
    }

    listLimitChange = (e) =>{
        this.setState({limit: e},()=>{this.RefreshList()})
    }

    render() {
        const { name, deptId, userList, limit, skip, count } = this.state;
        let list = [{
            width: 130,
            key: "user",
            value: React.language("name"),
            title: true,//给元素添加title属性
            onCellCreate: (items, value) => {
                const bg = value ? value.nickname ? BsyUtils.formatUserThumb(value.nickname.toString()) : '' : '';
                return <ul className="user-list" title={value.nickname}>
                    <li className="user-item">
                        {value.avatarurl ? <img src={value.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                        <div className="user-name">{value.nickname}</div>
                    </li>
                </ul>
            },
        }, {
            width: 160,
            key: "mobile",
            value: React.language("phone"),
            onCellCreate: (items, value) => {
                return <>
                    <span title={value.phone} className="text">{value.phone }</span>
                </>
                
            },
        }, {
            width: 170,
            key: "email",
            value: React.language("email"),
            onCellCreate: (items, value) => {
                return <>
                    <span title={value.email} className="text">{value.email }</span>
                </>
            },
        }];
        return (
            <div className="CorpDeptUserPane">
                <div className="header-pane">
                    <div className="avatar">
                        <i className="icon-form-new-flow"></i>
                    </div>
                    <div className="headerDetail">
                        <div className="name">
                            <span className="tName">{name}</span>
                        </div>
                        {/* <div className="account">
                            <span className="detailTitle">{React.language('receipt.account') + "："}</span>
                            <span className="detailText">{deptId}</span>
                        </div> */}
                    </div>
                    <div className="alertClose">
                        <i onClick={this.closeAlert} className="icon-close-large" />
                    </div>
                </div>

                <div className="detailCont">
                    <BsyTableList
                        getValue={this.getTableValue}
                        key={new Date().getTime()}
                        limit={limit}
                        skip={skip}
                        skipChange={this.skipChange}
                        listLimitChange={this.listLimitChange}
                        noDarg={true}
                        multiple={false}
                        count={count}
                        hasTurnPage={count > 20}
                        noMenu={true}
                        styleType={window.mode}
                        userCont={{
                            users: userList || []
                        }}
                        list={list}
                    />
                    {
                        count === 0 && <div className="dock-empty">
                            <img src={emptyDockUser} alt="" />
                            <div className="dock-empty-tip">{React.language('contact.docker.dept.user.empty')}</div>
                        </div>
                    }
                </div>
                <div className="alertFooter">
                    {
                        <BsyIconBtn
                            text={React.language('close.detail')}
                            click={this.closeAlert}
                            iconName=""
                            type="border-blue"
                            mode={window.mode}
                        />
                    }
                </div>
            </div>
        )
    }
}

export default CorpDeptUserPane